var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gp2-qtl-drawer" }, [
    _c("p", { staticClass: "vks-ui-intro" }, [
      _vm._v(
        " QTL associations for the searching region (downsampled). Check at least one QTL type and one tissue to show matching rows; starring a variant on the zoomed-in plot always keeps it visible here. "
      ),
    ]),
    _c(
      "section",
      { staticClass: "vks-drawer-section vks-drawer-section--controls" },
      [
        _c(
          "div",
          {
            staticClass: "vks-ui-tabs",
            attrs: { role: "tablist", "aria-label": "QTL evidence panels" },
          },
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "button",
              {
                key: tab.id,
                staticClass: "vks-ui-tab",
                class: { "is-active": _vm.activeTab === tab.id },
                attrs: {
                  id: `gp2-qtl-tab-${tab.id}`,
                  type: "button",
                  role: "tab",
                  "aria-selected": _vm.activeTab === tab.id ? "true" : "false",
                  "aria-controls": `gp2-qtl-panel-${tab.id}`,
                },
                on: {
                  click: function ($event) {
                    _vm.activeTab = tab.id
                  },
                },
              },
              [_vm._v(" " + _vm._s(tab.label) + " ")]
            )
          }),
          0
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === "type-tissue",
                expression: "activeTab === 'type-tissue'",
              },
            ],
            staticClass: "vks-ui-tab-panel",
            attrs: {
              id: "gp2-qtl-panel-type-tissue",
              role: "tabpanel",
              "aria-labelledby": "gp2-qtl-tab-type-tissue",
            },
          },
          [
            _c("section", { staticClass: "vks-ui-section" }, [
              _c("p", { staticClass: "vks-ui-section-title" }, [
                _vm._v("QTL types"),
              ]),
              _c(
                "ul",
                {
                  staticClass: "gp2-qtl-check-list",
                  attrs: { role: "group", "aria-label": "QTL types" },
                },
                _vm._l(_vm.typeOptions, function (type) {
                  return _c(
                    "li",
                    { key: `type-${type}`, staticClass: "gp2-qtl-check-item" },
                    [
                      _c("label", { staticClass: "gp2-qtl-check" }, [
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: { checked: _vm.isTypeSelected(type) },
                          on: {
                            change: function ($event) {
                              return _vm.onToggleType(type, $event)
                            },
                          },
                        }),
                        _c("span", [_vm._v(_vm._s(type))]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _c("section", { staticClass: "vks-ui-section" }, [
              _c("p", { staticClass: "vks-ui-section-title" }, [
                _vm._v("Tissues"),
              ]),
              _c(
                "ul",
                {
                  staticClass: "gp2-qtl-check-list",
                  attrs: { role: "group", "aria-label": "Tissues" },
                },
                _vm._l(_vm.tissueOptions, function (tissue) {
                  return _c(
                    "li",
                    {
                      key: `tissue-${tissue}`,
                      staticClass: "gp2-qtl-check-item",
                    },
                    [
                      _c("label", { staticClass: "gp2-qtl-check" }, [
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: { checked: _vm.isTissueSelected(tissue) },
                          on: {
                            change: function ($event) {
                              return _vm.onToggleTissue(tissue, $event)
                            },
                          },
                        }),
                        _c("span", [_vm._v(_vm._s(tissue))]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === "filter-setting",
                expression: "activeTab === 'filter-setting'",
              },
            ],
            staticClass: "vks-ui-tab-panel",
            attrs: {
              id: "gp2-qtl-panel-filter-setting",
              role: "tabpanel",
              "aria-labelledby": "gp2-qtl-tab-filter-setting",
            },
          },
          [
            _c("section", { staticClass: "vks-ui-section" }, [
              _c("p", { staticClass: "vks-ui-section-title" }, [
                _vm._v("Filters"),
              ]),
              _c("label", { staticClass: "gp2-qtl-pvalue-filter" }, [
                _c("span", { staticClass: "gp2-qtl-field-label" }, [
                  _vm._v("P-value"),
                ]),
                _c("input", {
                  staticClass: "gp2-qtl-pvalue-input",
                  attrs: {
                    type: "text",
                    inputmode: "decimal",
                    placeholder: "No maximum",
                    "aria-label": "Maximum QTL p-value",
                  },
                  domProps: { value: _vm.pValueMax },
                  on: { input: _vm.onPValueInput },
                }),
              ]),
              _c("p", { staticClass: "vks-ui-hint" }, [
                _vm._v(
                  " Hides loaded rows with a p-value above this cutoff. Leave blank to show every loaded row. "
                ),
              ]),
            ]),
            _vm.geneOptions.length
              ? _c("section", { staticClass: "vks-ui-section" }, [
                  _c("p", { staticClass: "vks-ui-section-title" }, [
                    _vm._v("Genes"),
                  ]),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "gp2-qtl-check-list gp2-qtl-check-list--genes",
                      attrs: { role: "group", "aria-label": "Genes" },
                    },
                    _vm._l(_vm.geneOptions, function (gene) {
                      return _c(
                        "li",
                        {
                          key: `gene-${gene}`,
                          staticClass: "gp2-qtl-check-item",
                        },
                        [
                          _c("label", { staticClass: "gp2-qtl-check" }, [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: { checked: _vm.isGeneSelected(gene) },
                              on: {
                                change: function ($event) {
                                  return _vm.onToggleGene(gene, $event)
                                },
                              },
                            }),
                            _c("span", [_vm._v(_vm._s(gene))]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _c("p", { staticClass: "vks-ui-hint" }, [
                    _vm._v(
                      " Leave all unchecked to show every gene. Checking one or more limits the table and plots to those genes. "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]
        ),
      ]
    ),
    _c(
      "section",
      { staticClass: "vks-drawer-section vks-drawer-section--table" },
      [
        _c("p", { staticClass: "vks-ui-section-title" }, [
          _vm._v("QTL associations"),
        ]),
        _vm.loading
          ? _c("div", { staticClass: "vks-ui-status" }, [
              _vm._v("Loading QTL associations…"),
            ])
          : _vm.error
          ? _c(
              "div",
              { staticClass: "vks-ui-error", attrs: { role: "alert" } },
              [_vm._v(_vm._s(_vm.error))]
            )
          : _vm.showTable
          ? _c("GP2BrowserQtlTable", {
              attrs: {
                rows: _vm.filteredRows,
                "starred-variant-ids": _vm.starredVariantIds,
                utils: _vm.utils,
              },
              on: {
                "toggle-star-variant": function ($event) {
                  return _vm.$emit("toggle-star-variant", $event)
                },
              },
            })
          : _c("p", { staticClass: "vks-ui-hint" }, [
              _vm._v(
                " Select at least one QTL type and one tissue to view evidence. "
              ),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }